import { Overview } from "@/components/Account/Overview";
import { Transaction } from "@/components/Transaction";
import classNames from "classnames";
import { FunctionComponent, ReactElement, useCallback, useEffect } from "react";
import { useToggle } from "react-use";
import classes from "./Account.module.scss";
import { IAccountProps } from "./types";

export const Account: FunctionComponent<IAccountProps> = (
  props: IAccountProps
): ReactElement<IAccountProps> => {
  const { account, transactions, onClose, onLoadTransactions, ...restProps } =
    props;
  const [loading, toggleLoading] = useToggle(false);

  const doLoad = useCallback(async (): Promise<void> => {
    try {
      toggleLoading(true);
      await onLoadTransactions();
    } finally {
      toggleLoading(false);
    }
  }, []);

  useEffect((): void => {
    doLoad();
  }, [account]);

  return (
    <div className="modal active" {...restProps}>
      <div className={classNames(["modalContent", classes.content])}>
        <Overview account={account} />
        <Transaction.History
          account={account}
          loading={loading}
          transactions={transactions}
        />
      </div>
      <div className="modalContent" />
    </div>
  );
};
